import React from 'react';

const Footer = () => {

  return (
    <>
         {/* main-footer */}
         <footer className="main-footer p_relative">
            <div className="footer-top">
                <div className="auto-container">
                    <div className="top-inner">
                        <ul className="footer-menu">
                            <li><a href="/">Management</a></li>
                            {/* <li><a href="/">About Us</a></li> */}
                            <li><a href="/">Hospital</a></li>
                        </ul>
                        <div className="footer-logo" style={{display: 'none'}}>
                            <figure className="logo"><a href="/"><img src="assets/images/logo_new.jpeg" alt="" className="footer-logo-img" style={{width: '66.67%', height: 'auto'}} /></a></figure>
                        </div>
                        <ul className="footer-menu">
                            <li><a href="/">Career</a></li>
                            <li><a href="/">Staff</a></li>
                            <li><a href="/">Contact</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="widget-section">
                <div className="auto-container">
                    <div className="row clearfix">
                        <div className="col-lg-4 col-md-6 col-sm-12 footer-column">
                            <div className="about-widget footer-widget mr_40">
                                <div className="widget-title">
                                    <h3>About</h3>
                                </div>
                                <div className="widget-content">
                                    <p>At our eye care hospital, we are dedicated to providing exceptional care and personalized attention to each and every one of our patients. <br />Our experienced team of ophthalmologists and staff are committed to your eye health and well-being.</p>
                                    <ul className="social-links clearfix">
                                        <li><a href="https://www.facebook.com/profile.php?id=100091975440305&mibextid=ZbWKwL"><i className="fab fa-facebook-f"></i></a></li>
                                        <li><a href="https://instagram.com/sunshineadvancedeyecare?igshid=MzRlODBiNWFlZA=="><i className="fab fa-instagram"></i></a></li>
                                        <li style={{display: 'none'}}><a href="/"><i className="fab fa-twitter"></i></a></li>
                                        <li style={{display: 'none'}}><a href="/"><i className="fab fa-linkedin-in"></i></a></li>
                                        <li style={{display: 'none'}}><a href="/"><i className="fab fa-youtube"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 footer-column">
                            <div className="links-widget footer-widget ml_100">
                                <div className="widget-title">
                                    <h3>Links</h3>
                                </div>
                                <div className="widget-content">
                                    <ul className="links-list clearfix">
                                        <li><a href="/DoctorProfile">About</a></li>
                                        <li><a href="/Services">Facilities</a></li>
                                        <li><a href="/Testimonials">Testimonials</a></li>
                                        <li><a href="/Specialities">Specialities</a></li>
                                        <li><a href="/Contact">Location</a></li>
                                        <li><a href="/Contact">Contact</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-lg-2 col-md-6 col-sm-12 footer-column">
                            <div className="links-widget footer-widget ml_30">
                                <div className="widget-title">
                                    <h3>Services</h3>
                                </div>
                                <div className="widget-content">
                                    <ul className="links-list clearfix">
                                        <li><a href="/">About</a></li>
                                        <li><a href="/">Services</a></li>
                                        <li><a href="/">Job</a></li>
                                        <li><a href="/">opportunities</a></li>
                                        <li><a href="/">Location</a></li>
                                        <li><a href="/">Article</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div> */}
                        <div className="col-lg-5 col-md-6 col-sm-12 footer-column">
                            <div className="contact-widget footer-widget ml_50">
                                <div className="widget-title">
                                    <h3>Contacts</h3>
                                </div>
                                <div className="widget-content">
                                    <ul className="info clearfix">
                                        <li><a href="https://maps.app.goo.gl/Coc7TBGjEj715mDs6" target="_blank" rel="noopener noreferrer">D.No.87-1165, Hosanna Mandir Road, Nandyal Road, Revenue Colony, Kurnool, Andhra Pradesh 518002, India</a></li>
                                        <li><a href="tel:9963276070">9963276070</a></li>
                                        <li><a href="mailto:reddyg.spurthi@gmail.com">reddyg.spurthi@gmail.com</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-bottom centred">
                <div className="auto-container">
                    <div className="copyright"><p><a href="/">Sunshine Advanced EYE Care</a> &copy; 2026 All Right Reserved</p></div>
                </div>
            </div>
        </footer>
        {/* main-footer end */}
    </>
    );
  }
  
  export default Footer;